import { Trip } from "../types/trip";

// Function to check if a string is a UUID
const isUUID = (str: string): boolean => {
	const uuidRegex =
		/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
	return uuidRegex.test(str);
};

// Generic fetch function to reuse code (someday)
const fetchData = async <T>(url: string): Promise<T> => {
	try {
		const response = await fetch(url, {
			headers: {
				"Content-Type": "application/json",
			},
		});

		if (response.status === 404) {
			throw new Error("Tour no encontrado");
		}

		if (!response.ok) {
			const errorText = await response.text();
			console.error("Error response text:", errorText);
			throw new Error("Network response was not ok");
		}

		const contentType = response.headers.get("content-type");
		if (contentType && contentType.includes("application/json")) {
			return response.json();
		} else {
			const errorText = await response.text();
			console.error("Error: Expected JSON but received:", errorText);
			throw new Error("Received non-JSON response");
		}
	} catch (error) {
		console.error("Fetch error:", error);
		throw error;
	}
};

export const getDataTravel = async (identifier: string): Promise<Trip> => {
	// Determine if the identifier is a UUID or an alias
	// we must strip any query params before checking if it's uuid
	const cleanedIdentifier = identifier.split("?")[0];

	const endpoint = isUUID(cleanedIdentifier)
		? `/tours/${identifier}`
		: `/tours/alias/${identifier}`;

	const apiUrl = `${process.env.REACT_APP_API_URL}${endpoint}`;
	return fetchData<Trip>(apiUrl);
};
